const QUERIES = {
    popup: '.site-popup',
    toggle: '.site-popup-toggle',
    close: '.site-popup-close',
    window: '.site-popup-window'
}

/**
 * This feature is used to set popup behavior
 * 
 * @class Popup
 * @param {Object} [queries]
 */

export default class Popup {
    constructor (queries = QUERIES, callback = {}) { 
        this.document = document.documentElement;

        let popup;
        let toggle, close, inner = null;

        // Popup

        if (queries.popup && typeof queries.popup === 'string') {
            popup = document.querySelector(queries.popup);
        } else {
            popup = queries.popup;
        }

        if (!popup) popup = document.querySelector(QUERIES.popup);

        if (!popup) throw new Error('Popup not found');

        // Toggle

        if (queries.toggle && typeof queries.toggle === 'string') {
            toggle = document.querySelector(queries.toggle);
        } else {
            toggle = queries.toggle;
        }

        if (!toggle) toggle = document.querySelector(QUERIES.toggle);

        if (!toggle) toggle = null;

        // Close

        if (queries.close && typeof queries.close === 'string') {
            close = document.querySelector(queries.close);
        } else {
            close = queries.close;
        }

        if (!close) close = document.querySelector(QUERIES.close);

        if (!close) close = null;

        // Window

        if (queries.window && typeof queries.window === 'string') {
            inner = document.querySelector(queries.window);
        } else {
            inner = queries.window;
        }

        if (!inner) inner = document.querySelector(QUERIES.window);

        if (!inner) inner = null;

        this.popup = popup;
        this.toggle = toggle || null;
        this.close = close || null;
        this.inner = inner || null;
        this.callback = callback;

        this.init();
    }

    init () {
        window.addEventListener('click', (event) => {
            event.stopPropagation();

            this.handleClose();
        });

        if (this.toggle) {
            this.toggle.addEventListener('click', (event) => {
                event.stopPropagation();

                this.handleOpen();
            });
        }

        if (this.inner) {
            this.inner.addEventListener('click', (event) => {
                event.stopPropagation();
                
                this.handleOpen();
            });
        }

        const clientsNavigation = this.popup.querySelector('.block-03--popup-gallery-navigation');

        if (clientsNavigation) {
            clientsNavigation.addEventListener('click', (event) => {
                event.stopPropagation();

                this.handleOpen();
            });
        }

        if (this.close) {
            this.close.addEventListener('click', (event) => {
                event.stopPropagation();

                this.handleClose();
            });
        }
    }

    handleOpen () {
        if (this.document) this.document.classList.add('locked');

        if (this.popup.classList.contains('opened')) return;

        this.popup.classList.add('opened');

        if (this.callback.open) this.callback.open();
    }

    handleClose () {
        if (this.document) this.document.classList.remove('locked');

        if (!this.popup.classList.contains('opened')) return;

        this.popup.classList.remove('opened');

        if (this.callback.close) this.callback.close();
    }

    open () {
        this.handleOpen();
    }

    close () {
        this.handleClose();
    }
}

/**
 * Usage example
 * 
 * import Popup from 'components/popup';
 * 
 * new Popup({
 *  popup: '.site-popup[data-popup=popup]',
 *  toggle: '.site-popup-toggle[data-popup=popup]',
 *  close: '.site-popup-close[data-popup=popup]',
 *  window: '.site-popup-window[data-popup=popup]'
 * });
 * 
 * OR
 * 
 * new Popup({
 *  popup: '.site-popup[data-popup=popup]',
 *  close: '.site-popup-close[data-popup=popup]'
 * }).open();
 * 
 */
